import { Subheader, NavBrand, Span, NavStart } from "@goodfill/ui-components";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { route } from "../../routes";

export const AccountSubheader = (props: { selected: "portfolio" | "accountSettings" }) => {
  const navigate = useNavigate();
  const goToPortfolio = useCallback(() => {
    navigate(route.accountPortfolio());
  }, [navigate]);
  const goToAccountSettings = useCallback(() => {
    navigate(route.personalInformation());
  }, [navigate]);

  return (
    <Subheader>
      <NavBrand>
        <Span white={true} uppercase={true} font="black" size="4xl">
          My Profile
        </Span>
      </NavBrand>

      <NavStart>
        <Span
          white={true}
          font={props.selected === "portfolio" ? "bold" : "medium"}
          underline={props.selected === "portfolio"}
          selectNone={props.selected === "portfolio"}
          onClick={goToPortfolio}
        >
          Portfolio
        </Span>
        <Span
          white={true}
          font={props.selected === "accountSettings" ? "bold" : "medium"}
          underline={props.selected === "accountSettings"}
          selectNone={props.selected === "accountSettings"}
          onClick={goToAccountSettings}
        >
          Account Settings
        </Span>
      </NavStart>
    </Subheader>
  );
};
